import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";

const routes = [
  {
    path: "/",
    name: "home",
    redirect: { name: "signIn" },
  },
  {
    path: "/signIn",
    name: "signIn",
    component: () => import("../views/Login/view/LoginView.vue"),
  },
  {
    path: "/calendar",
    name: "calendar",
    component: () => import("../views/scheduling/views/calendarListPage.vue"),
    meta: { reqAuth: true },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () =>
      import("../views/scheduling/components/calendar/dashBoard.vue"),
    meta: { reqAuth: true },
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/scheduling/:name",
    name: "scheduling",
    component: () => import("../views/scheduling/views/schedulingPage.vue"),
    meta: { reqAuth: false },
  },
  {
    path: "/agenda-config",
    name: "agenda-config",
    component: () => import("../views/scheduling/views/agendaConfigPage.vue"),
    meta: { reqAuth: true },
    children: [
      {
        path: "createAgenda",
        name: "agenda-config-form",
        component: () =>
          import("../views/scheduling/components/agenda/formAgenda.vue"),
      },
      {
        path: "agenda",
        name: "agenda-config-agenda",
        component: () => import("../views/scheduling/views/agendaListPage.vue"),
        children: [
          {
            path: "",
            name: "agenda-config-agenda-list-agenda",
            component: () =>
              import("../views/scheduling/components/agenda/agendaList.vue"),
          },
          {
            path: "editarAgenda/:id",
            name: "agenda-config-edit",
            component: () =>
              import("../views/scheduling/components/agenda/formAgenda.vue"),
          },
        ],
      },
      {
        path: "vacancies",
        name: "agenda-config-vacancies",
        meta: { reqAuth: true },
        component: () =>
          import("../views/scheduling/components/agenda/vacanciesForm.vue"),
      },
      {
        path: "custom",
        name: "agenda-config-custom",
        meta: { reqAuth: true },
        component: () =>
          import("../views/scheduling/components/agenda/customFormAgenda.vue"),
      },
      {
        path: "event-form",
        name: "agenda-config-event-form",
        meta: { reqAuth: true },
        component: () =>
          import("../views/scheduling/components/agenda/eventForm.vue"),
      },
      {
        path: "info-form",
        name: "agenda-config-info-form",
        meta: { reqAuth: true },
        component: () =>
          import("../views/scheduling/components/agenda/infoAgenda.vue"),
      },
    ],
  },
  {
    path: "/admin",
    name: "panelAdmin",
    meta: { reqAuth: true },
    component: () => import("../views/AdminPanel/view/AdminPanelView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to, from, next) => {
  let auth = store.getters.getAuth;
  const isSignInRoute = to.path === "/signIn";
  const isSchedulingRoute = to.fullPath.includes("scheduling");
  const requiresAuth = to.matched.some((record) => record.meta.reqAuth);

  if (isSchedulingRoute) {
    next();
  } else if (isSignInRoute && auth) {
    next({ path: "/calendar", query: { redirect: to.fullPath } });
  } else if (requiresAuth && !auth) {
    next({ path: "/signIn", query: { redirect: to.fullPath } });
  } else {
    next();
  }
});
export default router;
